import { createFileRoute } from "@tanstack/react-router";

import { ComingSoonPlaceholder } from "@/features/billing";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/$projectId/invoices",
)({
  component: ComingSoonPlaceholder,
});
